export const cardStyle = {
	height: "100vh",
	padding: 12,
	overflowY: "scroll" as const,
};

export const ERR_NO_ENOUGH_DATA = "Vous n'avez pas selectionné assez de lignes.";
export const ERR_NO_TITLE_FOR_LABEL =
	"Ce label n'a pas encore de titre à afficher. Merci de faire remonter cette erreur ainsi que le nom du label, merci.";
